import _ from "lodash";
window._ = _;

import "./bootstrap";

import jquery from "jquery";
window.jQuery = jquery;
window.$ = jquery;

window.toastr = require("./components/toastr");

import "flatpickr";
const Indonesia = require("flatpickr/dist/l10n/id.js").default.id;

import "select2";

require("./components/bulma-modal-fx");

import DataTable from "datatables.net-bm";

flatpickr(".daterange", {
	mode: "range",
	altInput: true,
	altFormat: "j F Y",
	maxDate: new Date(),
	parseDate: true,
	locale: Indonesia,
});

$("input[data-type='currency']").on({
	keyup: function () {
		formatCurrency($(this));
	},
	blur: function () {
		formatCurrency($(this), "blur");
	},
});

document.addEventListener("input", function (event) {
	const input = event.target;

	if (input?.dataset?.type !== "integer") {
		return;
	}

	let value = input.value;

	// Hapus karakter selain angka
	value = value.replace(/[^0-9]/g, "");

	// Hapus nol di depan, kecuali angka 0
	value = value.replace(/^0+(?=\d)/, "");

	input.value = value;
});

document.addEventListener("keydown", function (event) {
	const input = event.target;

	if (input?.dataset?.type !== "integer") {
		return;
	}

	const blockedKeys = ["-", "+", "e", "E", ",", "."];

	if (blockedKeys.includes(event.key)) {
		event.preventDefault();
	}
});

function formatNumber(n) {
	return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function formatCurrency(input, blur) {
	var input_val = input.val();

	if (input_val === "") {
		return;
	}
	var original_len = input_val.length;

	var caret_pos = input.prop("selectionStart");

	if (input_val.indexOf(",") >= 0) {
		var decimal_pos = input_val.indexOf(",");
		var left_side = input_val.substring(0, decimal_pos);
		var right_side = input_val.substring(decimal_pos);
		left_side = formatNumber(left_side);
		right_side = formatNumber(right_side);
		if (blur === "blur") {
			right_side += "00";
		}
		right_side = right_side.substring(0, 2);
		input_val = left_side + "," + right_side;
	} else {
		input_val = formatNumber(input_val);
		input_val = input_val;
		if (blur === "blur") {
			input_val += ",00";
		}
	}
	input.val(input_val);
	var updated_len = input_val.length;
	caret_pos = updated_len - original_len + caret_pos;
	input[0].setSelectionRange(caret_pos, caret_pos);
}

$("input[data-type='persentase']").on({
	keyup: function () {
		formatCurrency($(this));
	},
	blur: function () {
		formatCurrency($(this), "blur");
	},
});

// HANYA ANGKA (tanpa titik pemisah ribuan)
function formatNumberOnly(n) {
	return n.replace(/[^0-9]/g, "");
}

function formatPersentase(input, blur) {
	var input_val = input.val();

	if (input_val === "") {
		return;
	}

	var original_len = input_val.length;
	var caret_pos = input.prop("selectionStart");

	// Ganti titik => koma
	input_val = input_val.replace(/\./g, ",");

	var firstCommaIndex = input_val.indexOf(",");
	if (firstCommaIndex !== -1) {
		var left = input_val.substring(0, firstCommaIndex);
		var right = input_val.substring(firstCommaIndex + 1);

		// GUNAKAN formatNumberOnly, BUKAN formatNumber!
		left = formatNumberOnly(left);
		right = formatNumberOnly(right);

		if (left === "") left = "0";

		var num = parseInt(left || "0", 10);
		if (num > 100) {
			left = "100";
			right = "00";
		}

		if (blur === "blur") {
			right = (right + "00").substring(0, 2);
		} else {
			right = right.substring(0, 2);
		}

		input_val = right.length ? left + "," + right : left;
	} else {
		input_val = formatNumberOnly(input_val); // JANGAN formatNumber!

		if (input_val === "") {
			input_val = "0";
		}

		var numOnly = parseInt(input_val || "0", 10);
		if (numOnly > 100) {
			input_val = "100";
		}

		if (blur === "blur") {
			input_val = input_val + ",00";
		}
	}

	input.val(input_val);
	var updated_len = input_val.length;
	caret_pos = updated_len - original_len + caret_pos;
	input[0].setSelectionRange(caret_pos, caret_pos);
}

$(".view-password").click(function () {
	var check_attr = $(this).parent().find('input[type="password"]').attr("type");
	if (check_attr == "password") {
		$(this).parent().find('input[type="password"]').attr("type", "text");
		$(this).find("img").attr("src", "/images/icons/eye-close.svg");
	} else {
		$(this).parent().find('input[type="text"]').attr("type", "password");
		$(this).find("img").attr("src", "/images/icons/eye.svg");
	}
});

$(".navbar-burger").click(function () {
	$("aside").toggleClass("is-active");
});
